import {MenuList} from '@chakra-ui/react'
import React from 'react'
import PropTypes from 'prop-types'
import {RemoveMenuRole} from './StokkeMenuItem'

const StokkeMenuList = ({as, ...props}) => {
    return <MenuList {...props} as={RemoveMenuRole} propagateAs={as} />
}

StokkeMenuList.propTypes = {
    as: PropTypes.elementType
}

export default StokkeMenuList
